import { Select } from '@codecorp/components'
import { useCountryGetCountriesQuery } from '@codecorp/web-api-wrapper'

export const CountryInput = ({
    name,
    defaultValue,
}: {
    name: string
    defaultValue?: string
    customValidity?: string
}) => {
    const { data: countries } = useCountryGetCountriesQuery()

    return (
        <Select
            defaultValue={defaultValue}
            small
            items={
                countries?.map(({ name: label, countryCode: value }) => ({
                    label,
                    value,
                })) ?? []
            }
            name={name}
        />
    )
}
